export enum EPhoneType {
  MOBILE = `mobile`,
  LANDLINE = `landline`,
  FAX = `fax`,
}
